import styled from 'styled-components';
import { Box } from '@components/Box';
import { PlaceholderCloudImage } from '@components/CloudImage';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { Text } from '@components/typography';
import { Columns } from '@components/Columns';
import { TextPairing } from '@components/TextPairing';

export const WrapperBox = styled(Box)`
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const GuestMainTextContainer = styled(Text)`
  width: 524px;
  ${themeMediaQuery('sm')} {
    width: 424px;
  }
  ${themeMediaQuery('xl')} {
    width: 524px;
  }
`;

export const HeadTitleWrapper = styled(Box)`
  max-width: 654px;
  margin: 0 auto;
  margin-bottom: ${themeSpace(10)};
  ${themeMediaQuery('below_sm')} {
    max-width: 310px;
    margin-bottom: ${themeSpace(8)};
  }
`;

export const StyledColumns = styled(Columns)`
  ${themeMediaQuery('below_sm')} {
    padding-left: ${themeSpace(3)};
    padding-right: ${themeSpace(3)};
  }
  ${themeMediaQuery('sm')} {
    max-width: 55rem;
  }
  ${themeMediaQuery('md')} {
    max-width: 79.5rem;
  }
`;

export const StyledColumn = styled(Columns.Column)`
  margin-bottom: ${themeSpace(6)};
`;

export const StyledBox = styled(Box)`
  border-radius: 12px;
  text-align: center;
`;

export const StyledPlaceholderCloudImage = styled(PlaceholderCloudImage)`
  padding-top: ${themeSpace(7)};
  ${themeMediaQuery('below_sm')} {
    min-width: 260px;
    min-height: 235px;
    width: 260px;
    height: 235px;
  }
  ${themeMediaQuery('sm')} {
    width: 220px;
    padding-left: ${themeSpace(4)};
    padding-right: ${themeSpace(4)};
  }
  ${themeMediaQuery('md')} {
    min-width: 330px;
    min-height: 290px;
    width: 330px;
    height: 290px;
    padding-left: 0;
    padding-right: 0;
  }
`;

export const StyledTextPairingOragnize = styled(TextPairing)`
  .text-pairing-title {
    width: 185px;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-body {
      width: 274px;
    }
  }
  ${themeMediaQuery('sm')} {
    .text-pairing-body {
      width: 213px;
    }
  }
  ${themeMediaQuery('md')} {
    .text-pairing-body {
      width: 250px;
    }
  }
`;

export const StyledTextPairingCommunicate = styled(TextPairing)`
  .text-pairing-title {
    width: 258px;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-body {
      width: 274px;
    }
  }
  ${themeMediaQuery('sm')} {
    .text-pairing-body {
      width: 213px;
    }
  }
  ${themeMediaQuery('md')} {
    .text-pairing-body {
      width: 244px;
    }
  }
`;

export const StyledTextPairingTrack = styled(TextPairing)`
  .text-pairing-title {
    width: 274px;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-body {
      width: 280px;
    }
  }
  ${themeMediaQuery('sm')} {
    .text-pairing-body {
      width: 270px;
    }
  }
  ${themeMediaQuery('md')} {
    .text-pairing-body {
      width: 300px;
    }
  }
`;
